import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import "./App.css";

/* PUBLIC PAGES */
import Home from "./Pages/Home";
import About from "./Pages/About";
import Products from "./Pages/Products";
import Contact from "./Pages/Contact";
import Packages from "./Pages/Packages";
import Privacypolicy from "./Pages/privacypolicy";
import Terms from "./Pages/terms";

/* COMPONENTS */
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ScrollToTop from "./Components/ScrollToTop";
import FloatingButtons from "./Components/FloatingButtons";
import Loader from "./Components/Loader";

/* ADMIN */
import Login from "./Pages/Admin/Login";
import Dashboard from "./Pages/Admin/Dashboard";
import ProtectedRoute from "./Pages/Admin/ProtectedRoute";

/* LAYOUT */
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target); // animate once
          }
        });
      },
      { threshold: 0.2 }
    );

    document.querySelectorAll(".anim").forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, [location.pathname]); // ✅ VERY IMPORTANT

  return (
    <>
      <ScrollToTop />
      {!isAdminRoute && <Header />}
      {children}
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <FloatingButtons />}
    </>
  );
};


function App() {
  const [loading, setLoading] = useState(true);
  const [initialVisit, setInitialVisit] = useState(false);

  useEffect(() => {
    // Check if user already visited in this session
    const hasVisited = sessionStorage.getItem("vangal_first_visit");

    if (!hasVisited) {
      // First visit
      sessionStorage.setItem("vangal_first_visit", "true");
      setInitialVisit(true);
      const timer = setTimeout(() => {
        setLoading(false);
      }, 5000); // 5 seconds for first URL visit
      return () => clearTimeout(timer);
    } else {
      // Subsequent page loads or route changes
      setInitialVisit(false);
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2000); // 2 seconds for all other pages
      return () => clearTimeout(timer);
    }
  }, []);

  if (loading) return <Loader />;

  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          {/* PUBLIC */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/packages-design" element={<Packages />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
          <Route path="/terms" element={<Terms />} />

          {/* ADMIN */}
          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default App;
